import React from "react";

const SvgExport = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <style>{".Export_svg__st4{display:none;fill:#6afff8}"}</style>
    <g id="Export_svg__Obecn\xE9_ikony">
      <path
        d="M100 27.3c-40.2 0-72.7 32.6-72.7 72.7s32.6 72.7 72.7 72.7c40.2 0 72.7-32.6 72.7-72.7S140.2 27.3 100 27.3zm1.3 16.2c.6 0 1 .1 1.5.3.5.2.9.5 1.3.8l18 18.4c1.5 1.5 1.4 3.9 0 5.3-1.5 1.5-3.9 1.5-5.3 0L105 56.4V109c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8V56.3L85.6 68.1c-1.5 1.5-3.9 1.5-5.3 0-.7-.7-1.1-1.7-1.1-2.7 0-1 .4-1.9 1.1-2.7l18.3-18v-.1c.7-.7 1.7-1.1 2.7-1.1zM61 82.8h25c2 0 3.6 1.6 3.6 3.6S88 90 86 90H62.4v42.7H140V90.1h-23.9c-2 0-3.6-1.6-3.6-3.6s1.6-3.6 3.6-3.6h25.3c3.2 0 5.9 2.4 5.9 5.6v46c0 3.2-2.8 5.6-5.9 5.6H61c-3.2 0-5.9-2.4-5.9-5.6v-46c0-3.3 2.8-5.7 5.9-5.7z"
        id="Export_svg__Export"
      />
    </g>
    <g id="Export_svg__Bo\u010Dn\xED_menu">
      <circle className="Export_svg__st4" cx={-122.8} cy={100} r={126.4} />
      <circle className="Export_svg__st4" cx={-120} cy={100} r={126.4} />
      <circle className="Export_svg__st4" cx={100} cy={100} r={126.4} />
      <circle className="Export_svg__st4" cx={320} cy={100} r={126.4} />
    </g>
  </svg>
);

export default SvgExport;

